import { Award, ShieldCheck } from "lucide-react";
import threeMLogo from "@/assets/3m-logo.png.asset.json";

interface Props {
  variant?: "dark" | "light" | "compact";
  className?: string;
}

const ThreeMLogo = ({ className = "" }: { className?: string }) => (
  <img
    src={threeMLogo.url}
    alt="3M"
    width={120}
    height={64}
    loading="lazy"
    decoding="async"
    className={className}
  />
);


/**
 * 3M-badge med den officiella logotypen från BBN Nordic.
 */
export function ThreeMBadge({ variant = "dark", className = "" }: Props) {
  const isLight = variant === "light";

  if (variant === "compact") {
    return (
      <span
        className={`inline-flex items-center gap-2 rounded-sm border border-gold/40 bg-gold/10 px-2.5 py-1 ${className}`}
      >
        <ThreeMLogo className="h-5 w-auto" />

        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-gold-bright">
          Auktoriserad installatör
        </span>
      </span>
    );
  }

  return (
    <div
      className={`inline-flex items-stretch overflow-hidden rounded-md border ${
        isLight ? "border-gold/40 bg-white/60" : "border-gold/30 bg-navy-deep/40"
      } ${className}`}
    >
      <div className="flex items-center justify-center px-3 bg-white">
        <ThreeMLogo className="h-10 w-auto" />

      </div>
      <div className="flex flex-col justify-center px-3 py-1.5">
        <span
          className={`font-mono text-[9px] uppercase tracking-[0.22em] ${
            isLight ? "text-foreground/60" : "text-cream/80"
          }`}
        >
          Auktoriserad
        </span>
        <span
          className={`font-display text-[13px] leading-tight ${
            isLight ? "text-foreground" : "text-cream"
          }`}
        >
          installatör
        </span>
      </div>
    </div>
  );
}

export function CertifiedInstallerBlock({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const isLight = variant === "light";
  return (
    <div className={isLight ? "" : ""}>
      <h3
        className={`text-xs uppercase tracking-[0.2em] font-semibold mb-4 ${
          isLight ? "text-foreground/80" : "text-white/90"
        }`}

      >
        Certifierad installatör
      </h3>
      <div className="flex flex-col gap-3">
        <ThreeMBadge variant={variant} />
        <div className="flex items-center gap-3 text-xs">
          <ShieldCheck size={14} className="text-gold" />
          <span className={isLight ? "text-foreground/70" : "text-white/70"}>
            Solar Screen Certified Installer
          </span>
        </div>
        <div className="flex items-center gap-3 text-xs">
          <Award size={14} className="text-gold" />
          <span className={isLight ? "text-foreground/70" : "text-white/70"}>
            10 års produktgaranti — sedan 2008
          </span>
        </div>
      </div>
    </div>
  );
}
